/**
 * Product videos tagged [data-half-volume] start at 50% volume.
 * Browsers only allow sound to autoplay after a visitor has interacted with the
 * site, so we try playing with sound first and fall back to muted autoplay.
 * Muted videos still sit at 50%, so unmuting plays at half volume.
 */
const HALF = 0.5;

function setup(host) {
  const video = host.querySelector('video');
  if (!video || video.dataset.halfVolumeReady) return;
  video.dataset.halfVolumeReady = 'true';
  video.volume = HALF;

  video.muted = false;
  const attempt = video.play();
  if (attempt && typeof attempt.catch === 'function') {
    attempt.catch(() => {
      video.muted = true;
      video.play().catch(() => {});
    });
  }

  // First unmute after a muted start: make sure it's at half volume, not 100%.
  let adjusted = false;
  video.addEventListener('volumechange', () => {
    if (!adjusted && !video.muted) {
      adjusted = true;
      if (video.volume > HALF) video.volume = HALF;
    }
  });
}

function scan(root = document) {
  root.querySelectorAll('[data-half-volume]').forEach(setup);
}

scan();
new MutationObserver(() => scan()).observe(document.body, { childList: true, subtree: true });
